import * as React from 'react';
import * as I18n from 'i18n-js';
import track, { TrackingProp } from 'react-tracking';

import bind from '../bind';
import FilterLink from './filter_link';
import SortSelect from './sort_select';
import { Filter } from './search_filters';
import SidebarToggle from './sidebar_toggle';

interface IProps {
  sort?: Filter;
  tracking?: TrackingProp;
}

@track({ componentName: 'SearchControls' })
export default class SearchControls extends React.Component<IProps, null> {
  @bind
  handleClick(evt) {
    this.props.tracking.trackEvent({
      entityId: evt.target.dataset.condition,
      url: evt.target.href,
    });
  }

  render() {
    return (
      <div className="grid-filter">
        {this.props.sort && (
          <div className="grid-filter__conditions">
            <FilterLink
              className="grid-filter__action"
              rel="nofollow"
              data-condition="used"
              activeClassName="grid-filter__action--active"
              params={{ condition: 'used' }}
              onClick={this.handleClick}
            >
              {I18n.t('commons.searchControls.used')}
            </FilterLink>
            <FilterLink
              className="grid-filter__action"
              rel="nofollow"
              data-condition="new"
              activeClassName="grid-filter__action--active"
              params={{ condition: 'new' }}
              onClick={this.handleClick}
            >
              {I18n.t('commons.searchControls.new')}
            </FilterLink>
          </div>
        )}
        <div className="grid-filter__mobile-toggle">
          <SidebarToggle open />
        </div>
        {this.props.sort && (
          <div className="grid-filter__sort">
            <SortSelect sort={this.props.sort} />
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/src/components/search_controls.tsx